angular.module('angus.controllers').controller('etlStatusSettingsCtrl', [
  '$scope',
  function ($scope) {

  }
]);
